module.exports = __webpack_public_path__ + "img/oxford-footer-bg-m.b047b4b0.png";